/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const launch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.857 2H2v12h12v-3.857M8.429 7.57 14 2m0 0H9.714M14 2v4.286"
    />
  </svg>
)
export default launch
